
export const LOGIN_IN_PROGRESS = "LOGIN_IN_PROGRESS";
export const LOGIN_SUCCESSFUL = "LOGIN_SUCCESSFUL";
export const LOGIN_FAILED = "LOGIN_FAILED";

export const GET_USER_DATA_IN_PROGRESS = "GET_USER_DATA_IN_PROGRESS";
export const GET_USER_DATA_SUCCESSFUL = "GET_USER_DATA_SUCCESSFUL";
export const GET_USER_DATA_FAILED = "GET_USER_DATA_FAILED";

export const LOGOUT = "LOGOUT";